import axios from "axios";

import ReactGA from "../../component/analytics/ReactGA";
import GTM from "react-gtm-module";
import { hotjar } from "react-hotjar";

import {
  KEY_ORDER_AFTER_SUCCESS_PAYMENT,
  KEY_ORDER_INFO,
  KEY_PAYMENT_INFO,
  KEY_REFRESH,
  KEY_PRE_INC_ORDER_INFO,
  KEY_PRE_INC_ORDER_INFO_BACKUP,
  KEY_UPSELL_ORDER_UPDATE,
  KEY_INC_SUMMARY,
  KEY_INC_SUMMARY_BACKUP,
  KEY_TRADEMARK_UPSELL_INFO,
  KEY_TRADEMARK_UPSELL_ORDER_INFO,
  removeItemSessionStorage,
  setItemSessionStorage,
  getItemSessionStorage,
} from "../../variables/Variables";
import * as Sentry from "@sentry/nextjs";
import { STORAGE_KEYS } from "../../constants/storage";
import {
  clearSessionValue,
  restoreSessionValue,
  storeSessionValue,
  restoreLocalValue,
  storeLocalValue,
} from "../../helpers/storage";
import { MAX_NUM_OF_PAYMENT_ATTEMPTS } from "../../constants/payment";
import { sha256 } from "crypto-hash";
import { createSaleEventBody } from "../../helpers/analytics";

export const address = (orderInfo, addressId) => {
  return {
    address1: orderInfo[addressId + "Address1"],
    address2: orderInfo[addressId + "Address2"],
    city: orderInfo[addressId + "City"],
    state: orderInfo[addressId + "State"],
    zip: orderInfo[addressId + "Zip"],
    country: orderInfo[addressId + "Country"],
    county: orderInfo[addressId + "County"],
  };
};

export const orderPayment = (paymentInfo, history) => {
  return async (dispatch) => {
    dispatch(paymentStarted());
    const paymentData = {
      firstName: paymentInfo.firstName,
      lastName: paymentInfo.lastName,
      cardNumber: paymentInfo.cardNumber.replace(/\s/g, ""),
      expMonth: paymentInfo.cardMonth,
      expYear: "20" + paymentInfo.cardYear,
      cvv: paymentInfo.cvc,
      processingOption: paymentInfo.processingOption,
      ...(paymentInfo.billingAddress !== "false" && {
        billingAddress: address(paymentInfo, "billingAddress")
      }),
      threeDSDetails: JSON.stringify(paymentInfo.threeDSDetails),
    };
    const isNumberOfPaymentAttemptsExceeded = checkIfNumberOfPaymentAttemptsExceeded();
    const isCardDataNotChanged = await checkIfCardDataNotChanged(paymentData);
    if (isCardDataNotChanged) {
      increaseBillingCounter();
    } else {
      resetBillingCounter();
    }

    if (isNumberOfPaymentAttemptsExceeded && isCardDataNotChanged) {
      dispatch(paymentFailure({ message: "Transaction Declined" }));
    } else {
      if (paymentInfo.discountCouponType) {
        paymentData.discountCouponType = paymentInfo.discountCouponType;
      }
      if (paymentInfo?.cavv) {
        paymentData.cavv = paymentInfo.cavv;
      }
      if (paymentInfo?.eci) {
        paymentData.eci = paymentInfo.eci;
      }
      // if(paymentInfo?.acsTransId) {
      //   paymentData.acsTransId = paymentInfo.acsTransId;
      // }
      if (paymentInfo?.xid) {
        paymentData.xid = paymentInfo.xid;
      }
      // if (paymentInfo?.threeDsStatus) {
      //   paymentData.threeDsStatus = paymentInfo.threeDsStatus;
      // }
      if (localStorage.getItem("source")) {
        paymentData.affId = localStorage.getItem("source");
      }
      if (localStorage.getItem("adAccount")) {
        paymentData.sourceValue1 = localStorage.getItem("adAccount");
      }
      if (localStorage.getItem("keyword")) {
        paymentData.sourceValue2 = localStorage.getItem("keyword");
      }
      if (paymentInfo?.campaignId) {
        paymentData.campaignId = paymentInfo.campaignId;
      }
      if (paymentInfo?.sourceValue1) {
        paymentData.sourceValue1 = paymentInfo.sourceValue1;
      }
      if (paymentInfo?.sourceValue2) {
        paymentData.sourceValue2 = paymentInfo.sourceValue2;
      }
      if (paymentInfo?.sourceValue3) {
        paymentData.sourceValue3 = paymentInfo.sourceValue3;
      }
      if (paymentInfo?.sourceValue4) {
        paymentData.sourceValue4 = paymentInfo.sourceValue4;
      }
      if (paymentInfo?.sourceValue5) {
        paymentData.sourceValue5 = paymentInfo.sourceValue5;
      }

      let config = {};
      let URL = process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + paymentInfo.orderId + "/payment-details";
      if (paymentInfo.token) {
        config = {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${paymentInfo.token}`,
        };
      } else {
        config = {
          Accept: "application/json",
          "Content-Type": "application/json",
        };
      }
      let params;
      if (localStorage.getItem("crmSessionId")) {
        let crmSessionId = localStorage.getItem("crmSessionId");
        params = { crmSessionId };
      }
      return axios
        .post(URL, paymentData, { headers: config, params })
        .then((paymentResponse) => {
          try {
            const data = JSON.parse(JSON.stringify(paymentResponse.data));
            return { ...paymentResponse, data };
          } catch (e) {
            throw { error: e, payload: { paymentResponse } };
          }
        })
        .then((paymentResponse) => {
          // send success action
          if (paymentResponse.data.products[0].paymentStatus === "Success") {
            hotjar.event("payment_successful");
            // clear session when payment success
            clearSessionValue(STORAGE_KEYS.billingInfo);
            clearSessionValue(STORAGE_KEYS.billingCounter);
            clearSessionValue(STORAGE_KEYS.billingHash);
            clearSessionValue(KEY_PAYMENT_INFO);
            clearSessionValue(KEY_REFRESH);
            clearSessionValue(KEY_PRE_INC_ORDER_INFO);
            clearSessionValue(KEY_PRE_INC_ORDER_INFO_BACKUP);
            clearSessionValue(KEY_INC_SUMMARY);
            clearSessionValue(KEY_INC_SUMMARY_BACKUP);
            let items = [
              {
                id: paymentResponse.data.order.crmOrderId,
                name: paymentResponse.data.order.productCodes[0],
                price: paymentResponse.data.order.total,
                category: "EIN",
                quantity: "1",
                currency: "USD",
              },
            ];

            GTM.dataLayer(createSaleEventBody(paymentResponse.data));

            if (process.env.NEXT_PUBLIC_REACT_APP_GA !== "") {
              ReactGA.plugin.execute("ecommerce", "addItem", {
                id: paymentResponse.data.order.crmOrderId,
                name: paymentResponse.data.order.productCodes[0],
                price: paymentResponse.data.order.total,
                category: "EIN",
                quantity: "1",
                currency: "USD",
              });
              ReactGA.plugin.execute("ecommerce", "addTransaction", {
                id: paymentResponse.data.order.crmOrderId, // the same as for addItem to connect them
                revenue: paymentResponse.data.order.total, // obviously it's price * quantity
                currency: "USD",
              });
              ReactGA.plugin.execute("ecommerce", "send");
              ReactGA.plugin.execute("ecommerce", "clear");
            }
            storeSessionValue(KEY_ORDER_AFTER_SUCCESS_PAYMENT, paymentResponse.data);
            dispatch(paymentSuccess(paymentResponse.data));
            if (paymentResponse.data.products) {
              axios
                .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/upsell-offers", {
                  params: { active: true },
                  headers: { "Content-Type": "application/json" },
                })
                .then((response) => {
                  if (
                    response.data.length > 0 &&
                    response.data.some(
                      (product) =>
                        product.finishedProduct.code === paymentResponse.data.products[0].code.code &&
                        product.upsellOffer.code === "EIN_LLCIncorporation"
                    )
                  ) {
                    history.push("/LLCUpsellQuestion");
                  } else {
                    history.push("/ThankYou");
                  }
                })
                .catch((error) => {
                  history.push("/ThankYou");
                });
            } else {
              history.push("/ThankYou");
            }
          } else {
            if (!isCardDataNotChanged) {
              createBillingHash(paymentData);
              increaseBillingCounter();
            }
            hotjar.event("payment_declined");
            storeSessionValue(KEY_ORDER_AFTER_SUCCESS_PAYMENT, paymentResponse.data);
            dispatch(
              paymentFailure({
                orderStatus: paymentResponse.data.products[0].paymentStatus,
                message: paymentResponse.data.products[0].paymentStatus,
              })
            );
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            error.response.data.errors
              ? dispatch(paymentFailure({ message: error.response.data.errors[0] }))
              : dispatch(paymentFailure({ message: error.response.data.message }));
            if (!isCardDataNotChanged) {
              createBillingHash(paymentData);
              increaseBillingCounter();
            }
          } else if (error.request) {
            let salePage = window.location.href;
            let salePageURLArr = salePage.split("/");
            let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
            let URL = salePageURL + "/crm/orders/" + paymentInfo.orderId + "/payment-details";
            axios
              .post(URL, paymentData, { headers: config, params })
              .then((paymentResponse) => {
                try {
                  const data = JSON.parse(JSON.stringify(paymentResponse.data));
                  return { ...paymentResponse, data };
                } catch (e) {
                  throw { error: e, payload: { paymentResponse } };
                }
              })
              .then((paymentResponse) => {
                // send success action
                if (paymentResponse.data.products[0].paymentStatus === "Success") {
                  hotjar.event("payment_successful");
                  // clear session when payment success
                  clearSessionValue(STORAGE_KEYS.billingInfo);
                  clearSessionValue(STORAGE_KEYS.billingCounter);
                  clearSessionValue(STORAGE_KEYS.billingHash);
                  clearSessionValue(KEY_PAYMENT_INFO);
                  clearSessionValue(KEY_REFRESH);
                  clearSessionValue(KEY_PRE_INC_ORDER_INFO);
                  clearSessionValue(KEY_PRE_INC_ORDER_INFO_BACKUP);
                  clearSessionValue(KEY_INC_SUMMARY);
                  clearSessionValue(KEY_INC_SUMMARY_BACKUP);
                  let items = [
                    {
                      id: paymentResponse.data.order.crmOrderId,
                      name: paymentResponse.data.order.productCodes[0],
                      price: paymentResponse.data.order.total,
                      category: "EIN",
                      quantity: "1",
                      currency: "USD",
                    },
                  ];
                  GTM.dataLayer(createSaleEventBody(paymentResponse.data));

                  if (process.env.NEXT_PUBLIC_REACT_APP_GA !== "") {
                    ReactGA.plugin.execute("ecommerce", "addItem", {
                      id: paymentResponse.data.order.crmOrderId,
                      name: paymentResponse.data.order.productCodes[0],
                      price: paymentResponse.data.order.total,
                      category: "EIN",
                      quantity: "1",
                      currency: "USD",
                    });
                    ReactGA.plugin.execute("ecommerce", "addTransaction", {
                      id: paymentResponse.data.order.crmOrderId, // the same as for addItem to connect them
                      revenue: paymentResponse.data.order.total, // obviously it's price * quantity
                      currency: "USD",
                    });
                    ReactGA.plugin.execute("ecommerce", "send");
                    ReactGA.plugin.execute("ecommerce", "clear");
                  }
                  setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, paymentResponse.data);
                  dispatch(paymentSuccess(paymentResponse.data));
                  if (paymentResponse.data.products) {
                    axios
                      .get(salePageURL + "/crm/upsell-offers", {
                        params: { active: true },
                        headers: { "Content-Type": "application/json" },
                      })
                      .then((response) => {
                        if (
                          response.data.length > 0 &&
                          response.data.some(
                            (product) =>
                              product.finishedProduct.code === paymentResponse.data.products[0].code.code &&
                              product.upsellOffer.code === "EIN_LLCIncorporation"
                          )
                        ) {
                          history.push("/LLCUpsellQuestion");
                        } else {
                          history.push("/ThankYou");
                        }
                      })
                      .catch((error) => {
                        history.push("/ThankYou");
                      });
                  } else {
                    history.push("/ThankYou");
                  }
                } else {
                  hotjar.event("payment_declined");
                  setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, paymentResponse.data);
                  if (!isCardDataNotChanged) {
                    createBillingHash(paymentData);
                    increaseBillingCounter();
                  }
                  dispatch(
                    paymentFailure({
                      orderStatus: paymentResponse.data.products[0].paymentStatus,
                      message: paymentResponse.data.products[0].paymentStatus,
                    })
                  );
                }
              })
              .catch((error) => {
                if (!isCardDataNotChanged) {
                  createBillingHash(paymentData);
                  increaseBillingCounter();
                }
                if (error.response && error.response.data) {
                  error.response.data.errors
                    ? dispatch(paymentFailure({ message: error.response.data.errors[0] }))
                    : dispatch(paymentFailure({ message: error.response.data.message }));
                } else {
                  dispatch(paymentFailure({ message: error.message }));
                }
                Sentry.captureException(error);
              });
          } else {
            if (!isCardDataNotChanged) {
              createBillingHash(paymentData);
              increaseBillingCounter();
            }
            Sentry.captureException(error);
            dispatch(paymentFailure({ message: error.message }));
          }
        });
    }
  };
};

export const checkIfNumberOfPaymentAttemptsExceeded = () => {
  const billingCounter = restoreLocalValue(STORAGE_KEYS.billingCounter);
  return billingCounter >= MAX_NUM_OF_PAYMENT_ATTEMPTS;
};

export const checkIfCardDataNotChanged = async (cardData) => {
  const billingHash = restoreLocalValue(STORAGE_KEYS.billingHash);
  if (!billingHash) {
    return false;
  }
  let newHash = await sha256(JSON.stringify(cardData));
  return newHash === billingHash;
};

export const increaseBillingCounter = () => {
  const billingCounter = restoreLocalValue(STORAGE_KEYS.billingCounter) || 0;
  storeLocalValue(STORAGE_KEYS.billingCounter, billingCounter + 1);
};

export const resetBillingCounter = () => {
  storeLocalValue(STORAGE_KEYS.billingCounter, 0);
};

export const createBillingHash = async (cardData) => {
  const cardDataString = JSON.stringify(cardData);
  const billingHash = await sha256(cardDataString);
  storeLocalValue(STORAGE_KEYS.billingHash, billingHash);
};

export const paymentStarted = () => ({
  type: "PAYMENT_STARTED",
});

export const paymentSuccess = (order) => ({
  type: "PAYMENT_SUCCESS",
  order: order,
});

export const paymentFailure = (error) => ({
  type: "PAYMENT_FAILURE",
  error: error,
});

export const clearErrorMessage = () => ({
  type: "CLEAR_ERROR",
});
export const clearOrder = () => ({
  type: "CLEAR_ORDER",
});
export const checkOrder = (orderId, history) => {
  return (dispatch) => {
    dispatch(checkOrderStarted());
    return axios
      .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/ein-status/" + orderId, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // send success action
        dispatch(checkOrderSuccess(response.data));
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch(checkOrderFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .get(salePageURL + "/crm/orders/ein-status/" + orderId, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // send success action
              dispatch(checkOrderSuccess(response.data));
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                dispatch(checkOrderFailure({ message: error.response.data.message }));
              } else {
                dispatch(checkOrderFailure(error));
              }
            });
        } else {
          dispatch(checkOrderFailure(error));
        }
      });
  };
};
export const checkOrderStarted = () => ({
  type: "ORDER_STATUS_STARTED",
});

export const checkOrderSuccess = (order) => ({
  type: "ORDER_STATUS_SUCCESS",
  order: order,
});

export const checkOrderFailure = (error) => ({
  type: "ORDER_STATUS_FAILURE",
  error: error,
});

export const llcSubmit = (order, orderId, basicEinProducts, file, history) => {
  return (dispatch) => {
    dispatch(llcStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          dispatch(llcSuccess(response.data));

          const boiProductId = response.data.products?.find(({ code }) => code?.code === "EIN_BOI")?.id;

          if (file && boiProductId) {
            const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
            const formData = new FormData();
            formData.append("file", file);
            fetch(
              process.env.NEXT_PUBLIC_REACT_APP_API +
                "/orders/" +
                response.data.order.id +
                "/products/" +
                boiProductId +
                "/result-PDF?fileType=BOI_ID",
              {
                method: "POST",
                headers: { Authorization: `Bearer ${token?.token}` },
                body: formData,
              }
            ).then();
          }

          const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

          if (orderAfterPayment) {
            response.data.products?.forEach((product) => {
              orderAfterPayment.products.push(product);
            });

            setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
          }

          axios
            .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/upsell-offers", {
              params: { active: true },
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              const productCodes = basicEinProducts.map(({ code }) => code?.code);

              const isBOIUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                return (
                  productCodes.includes(finishedProduct?.code) &&
                  !productCodes.includes(upsellOffer?.code) &&
                  !disabled &&
                  upsellOffer?.code === "EIN_BOI"
                );
              });

              const isTrademarkUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                return (
                  productCodes.includes(finishedProduct?.code) &&
                  !productCodes.includes(upsellOffer?.code) &&
                  !disabled &&
                  upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                );
              });

              if (isBOIUpsell) {
                history.push("/BOIUpgrade");
              } else if (!isBOIUpsell && isTrademarkUpsell) {
                history.push("/TrademarkUpsellQuestion");
              } else {
                history.push("/ThankYou");
              }
            })
            .catch((e) => {
              history.push("/ThankYou");
            });
        } else {
          dispatch(llcFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(llcFailure({ message: error.response.data.errors[0] }))
            : dispatch(llcFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                dispatch(llcSuccess(response.data));

                const boiProductId = response.data.products?.find(({ code }) => code?.code === "EIN_BOI")?.id;

                if (file && boiProductId) {
                  const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
                  const formData = new FormData();
                  formData.append("file", file);
                  fetch(
                    salePageURL +
                      "/crm/orders/" +
                      response.data.order.id +
                      "/products/" +
                      boiProductId +
                      "/result-PDF?fileType=BOI_ID",
                    {
                      method: "POST",
                      headers: { Authorization: `Bearer ${token?.token}` },
                      body: formData,
                    }
                  ).then();
                }

                const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

                if (orderAfterPayment) {
                  response.data.products?.forEach((product) => {
                    orderAfterPayment.products.push(product);
                  });

                  setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
                }

                axios
                  .get(salePageURL + "/crm/upsell-offers", {
                    params: { active: true },
                    headers: { "Content-Type": "application/json" },
                  })
                  .then((response) => {
                    const productCodes = basicEinProducts.map(({ code }) => code?.code);

                    const isBOIUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                      return (
                        productCodes.includes(finishedProduct?.code) &&
                        !productCodes.includes(upsellOffer?.code) &&
                        !disabled &&
                        upsellOffer?.code === "EIN_BOI"
                      );
                    });

                    const isTrademarkUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                      return (
                        productCodes.includes(finishedProduct?.code) &&
                        !productCodes.includes(upsellOffer?.code) &&
                        !disabled &&
                        upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                      );
                    });

                    if (isBOIUpsell) {
                      history.push("/BOIUpgrade");
                    } else if (!isBOIUpsell && isTrademarkUpsell) {
                      history.push("/TrademarkUpsellQuestion");
                    } else {
                      history.push("/ThankYou");
                    }
                  })
                  .catch((e) => {
                    history.push("/ThankYou");
                  });
              } else {
                dispatch(llcFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(llcFailure({ message: error.response.data.errors[0] }))
                  : dispatch(llcFailure({ message: error.response.data.message }));
              } else {
                dispatch(llcFailure(error));
              }
            });
        } else {
          dispatch(llcFailure(error));
        }
      });
  };
};

export const delayedLLCSubmit = (order, orderId, basicEinProducts, file, history) => {
  return (dispatch) => {
    dispatch(llcStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-delayed-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          dispatch(llcSuccess(response.data));

          const boiProductId = response.data.products?.find(({ code }) => code?.code === "EIN_BOI")?.id;

          if (file && boiProductId) {
            const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
            const formData = new FormData();
            formData.append("file", file);
            fetch(
              process.env.NEXT_PUBLIC_REACT_APP_API +
                "/orders/" +
                response.data.order.id +
                "/products/" +
                boiProductId +
                "/result-PDF?fileType=BOI_ID",
              {
                method: "POST",
                headers: { Authorization: `Bearer ${token?.token}` },
                body: formData,
              }
            ).then();
          }

          removeItemSessionStorage(KEY_UPSELL_ORDER_UPDATE);
          removeItemSessionStorage(KEY_PRE_INC_ORDER_INFO);
          removeItemSessionStorage(KEY_PRE_INC_ORDER_INFO_BACKUP);
          removeItemSessionStorage(KEY_INC_SUMMARY);
          removeItemSessionStorage(KEY_INC_SUMMARY_BACKUP);

          const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

          if (orderAfterPayment) {
            response.data.products?.forEach((product) => {
              orderAfterPayment.products.push(product);
            });

            setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
          }

          axios
            .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/upsell-offers", {
              params: { active: true },
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              const productCodes = basicEinProducts.map(({ code }) => code?.code);

              const isBOIUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                return (
                  productCodes.includes(finishedProduct?.code) &&
                  !productCodes.includes(upsellOffer?.code) &&
                  !disabled &&
                  upsellOffer?.code === "EIN_BOI"
                );
              });

              const isTrademarkUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                return (
                  productCodes.includes(finishedProduct?.code) &&
                  !productCodes.includes(upsellOffer?.code) &&
                  !disabled &&
                  upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                );
              });

              if (isBOIUpsell) {
                history.push(
                  `/BOIUpgrade?order=${history.query.order}&token=${history.query.token}&campaignId=${
                    history.query.campaignId || 2
                  }`
                );
              } else if (!isBOIUpsell && isTrademarkUpsell) {
                history.push(
                  `/TrademarkUpsellQuestion?order=${history.query.order}&token=${history.query.token}&campaignId=${
                    history.query.campaignId || 2
                  }`
                );
              } else {
                history.push("/ThankYou");
              }
            })
            .catch((e) => {
              history.push("/ThankYou");
            });
        } else {
          dispatch(llcFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(llcFailure({ message: error.response.data.errors[0] }))
            : dispatch(llcFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-delayed-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                dispatch(llcSuccess(response.data));

                const boiProductId = response.data.products?.find(({ code }) => code?.code === "EIN_BOI")?.id;

                if (file && boiProductId) {
                  const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
                  const formData = new FormData();
                  formData.append("file", file);
                  fetch(
                    salePageURL +
                      "/crm/orders/" +
                      response.data.order.id +
                      "/products/" +
                      boiProductId +
                      "/result-PDF?fileType=BOI_ID",
                    {
                      method: "POST",
                      headers: { Authorization: `Bearer ${token?.token}` },
                      body: formData,
                    }
                  ).then();
                }

                removeItemSessionStorage(KEY_UPSELL_ORDER_UPDATE);
                removeItemSessionStorage(KEY_PRE_INC_ORDER_INFO);
                removeItemSessionStorage(KEY_PRE_INC_ORDER_INFO_BACKUP);
                removeItemSessionStorage(KEY_INC_SUMMARY);
                removeItemSessionStorage(KEY_INC_SUMMARY_BACKUP);

                const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

                if (orderAfterPayment) {
                  response.data.products?.forEach((product) => {
                    orderAfterPayment.products.push(product);
                  });

                  setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
                }

                axios
                  .get(salePageURL + "/crm/upsell-offers", {
                    params: { active: true },
                    headers: { "Content-Type": "application/json" },
                  })
                  .then((response) => {
                    const productCodes = basicEinProducts.map(({ code }) => code?.code);

                    const isBOIUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                      return (
                        productCodes.includes(finishedProduct?.code) &&
                        !productCodes.includes(upsellOffer?.code) &&
                        !disabled &&
                        upsellOffer?.code === "EIN_BOI"
                      );
                    });

                    const isTrademarkUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                      return (
                        productCodes.includes(finishedProduct?.code) &&
                        !productCodes.includes(upsellOffer?.code) &&
                        !disabled &&
                        upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                      );
                    });

                    if (isBOIUpsell) {
                      history.push(
                        `/BOIUpgrade?order=${history.query.order}&token=${history.query.token}&campaignId=${
                          history.query.campaignId || 2
                        }`
                      );
                    } else if (!isBOIUpsell && isTrademarkUpsell) {
                      history.push(
                        `/TrademarkUpsellQuestion?order=${history.query.order}&token=${
                          history.query.token
                        }&campaignId=${history.query.campaignId || 2}`
                      );
                    } else {
                      history.push("/ThankYou");
                    }
                  })
                  .catch((e) => {
                    history.push("/ThankYou");
                  });
              } else {
                dispatch(llcFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(llcFailure({ message: error.response.data.errors[0] }))
                  : dispatch(llcFailure({ message: error.response.data.message }));
              } else {
                dispatch(llcFailure(error));
              }
            });
        } else {
          dispatch(llcFailure(error));
        }
      });
  };
};

export const llcStarted = () => ({
  type: "LLC_STARTED",
});

export const llcSuccess = (order) => ({
  type: "LLC_SUCCESS",
  order: order,
});

export const llcFailure = (error) => ({
  type: "LLC_FAILURE",
  error: error,
});

export const trademarkSubmit = (order, file, orderId, history) => {
  return (dispatch) => {
    dispatch(trademarkStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          dispatch(trademarkSuccess(response.data));
          removeItemSessionStorage(KEY_TRADEMARK_UPSELL_INFO);

          if (file) {
            const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
            const formData = new FormData();
            formData.append("file", file);
            fetch(
              process.env.NEXT_PUBLIC_REACT_APP_API +
                "/orders/" +
                response.data.order.id +
                "/products/" +
                response.data.products[0].id +
                "/result-PDF?fileType=TRADEMARK_LOGO",
              {
                method: "POST",
                headers: { Authorization: `Bearer ${token?.token}` },
                body: formData,
              }
            ).then();
          }

          history.push("/MonexaUpsellQuestion");
        } else {
          dispatch(trademarkFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(trademarkFailure({ message: error.response.data.errors[0] }))
            : dispatch(trademarkFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                dispatch(trademarkSuccess(response.data));
                removeItemSessionStorage(KEY_TRADEMARK_UPSELL_INFO);

                if (file) {
                  const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
                  const formData = new FormData();
                  formData.append("file", file);
                  fetch(
                    salePageURL +
                      "/crm/orders/" +
                      response.data.order.id +
                      "/products/" +
                      response.data.products[0].id +
                      "/result-PDF?fileType=TRADEMARK_LOGO",
                    {
                      method: "POST",
                      headers: { Authorization: `Bearer ${token?.token}` },
                      body: formData,
                    }
                  ).then();
                }

                history.push("/MonexaUpsellQuestion");
              } else {
                dispatch(trademarkFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(trademarkFailure({ message: error.response.data.errors[0] }))
                  : dispatch(trademarkFailure({ message: error.response.data.message }));
              } else {
                dispatch(trademarkFailure(error));
              }
            });
        } else {
          dispatch(trademarkFailure(error));
        }
      });
  };
};

export const delayedTrademarkSubmit = (order, file, orderId, history) => {
  return (dispatch) => {
    dispatch(trademarkStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-delayed-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          dispatch(trademarkSuccess(response.data));
          setItemSessionStorage(KEY_TRADEMARK_UPSELL_ORDER_INFO, response.data);
          removeItemSessionStorage(KEY_TRADEMARK_UPSELL_INFO);

          if (file) {
            fetch(
              process.env.NEXT_PUBLIC_REACT_APP_API +
                "/orders/" +
                response.data.order.id +
                `/token?email=${response.data.customer.email}`,
              {
                method: "POST",
              }
            )
              .then((tokenResponse) => tokenResponse.json())
              .then((tokenObj) => {
                const formData = new FormData();
                formData.append("file", file);
                fetch(
                  process.env.NEXT_PUBLIC_REACT_APP_API +
                    "/orders/" +
                    response.data.order.id +
                    "/products/" +
                    response.data.products[0].id +
                    "/result-PDF?fileType=TRADEMARK_LOGO",
                  {
                    method: "POST",
                    headers: { Authorization: `Bearer ${tokenObj.token}` },
                    body: formData,
                  }
                ).then();
              });
          }

          history.push("/MonexaUpsellQuestion");
        } else {
          dispatch(trademarkFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(trademarkFailure({ message: error.response.data.errors[0] }))
            : dispatch(trademarkFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-delayed-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                dispatch(trademarkSuccess(response.data));
                setItemSessionStorage(KEY_TRADEMARK_UPSELL_ORDER_INFO, response.data);
                removeItemSessionStorage(KEY_TRADEMARK_UPSELL_INFO);

                if (file) {
                  fetch(
                    salePageURL +
                      "/crm/orders/" +
                      response.data.order.id +
                      `/token?email=${response.data.customer.email}`,
                    {
                      method: "POST",
                    }
                  )
                    .then((tokenResponse) => tokenResponse.json())
                    .then((tokenObj) => {
                      const formData = new FormData();
                      formData.append("file", file);
                      fetch(
                        salePageURL +
                          "/crm/orders/" +
                          response.data.order.id +
                          "/products/" +
                          response.data.products[0].id +
                          "/result-PDF?fileType=TRADEMARK_LOGO",
                        {
                          method: "POST",
                          headers: { Authorization: `Bearer ${tokenObj.token}` },
                          body: formData,
                        }
                      ).then();
                    });
                }

                history.push("/MonexaUpsellQuestion");
              } else {
                dispatch(trademarkFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(trademarkFailure({ message: error.response.data.errors[0] }))
                  : dispatch(trademarkFailure({ message: error.response.data.message }));
              } else {
                dispatch(trademarkFailure(error));
              }
            });
        } else {
          dispatch(trademarkFailure(error));
        }
      });
  };
};

export const trademarkStarted = () => ({
  type: "TRADEMARK_STARTED",
});

export const trademarkSuccess = (order) => ({
  type: "TRADEMARK_SUCCESS",
  order: order,
});

export const trademarkFailure = (error) => ({
  type: "TRADEMARK_FAILURE",
  error: error,
});

export const boiSubmit = (order, orderId, basicEinProducts, file, history) => {
  return (dispatch) => {
    dispatch(boiStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          dispatch(boiSuccess(response.data));

          if (file) {
            const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
            const formData = new FormData();
            formData.append("file", file);
            fetch(
              process.env.NEXT_PUBLIC_REACT_APP_API +
                "/orders/" +
                response.data.order.id +
                "/products/" +
                response.data.products[0].id +
                "/result-PDF?fileType=BOI_ID",
              {
                method: "POST",
                headers: { Authorization: `Bearer ${token?.token}` },
                body: formData,
              }
            ).then();
          }

          const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

          if (orderAfterPayment) {
            response.data.products?.forEach((product) => {
              orderAfterPayment.products.push(product);
            });

            setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
          }

          axios
            .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/upsell-offers", {
              params: { active: true },
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              const productCodes = basicEinProducts.map(({ code }) => code?.code);

              const isUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                return (
                  productCodes.includes(finishedProduct?.code) &&
                  !productCodes.includes(upsellOffer?.code) &&
                  !disabled &&
                  upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                );
              });

              if (isUpsell) {
                history.push("/TrademarkUpsellQuestion");
              } else {
                history.push("/ThankYou");
              }
            })
            .catch((e) => {
              history.push("/ThankYou");
            });
        } else {
          dispatch(boiFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(boiFailure({ message: error.response.data.errors[0] }))
            : dispatch(boiFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                dispatch(boiSuccess(response.data));

                if (file) {
                  const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
                  const formData = new FormData();
                  formData.append("file", file);
                  fetch(
                    process.env.NEXT_PUBLIC_REACT_APP_API +
                      "/orders/" +
                      response.data.order.id +
                      "/products/" +
                      response.data.products[0].id +
                      "/result-PDF?fileType=BOI_ID",
                    {
                      method: "POST",
                      headers: { Authorization: `Bearer ${token?.token}` },
                      body: formData,
                    }
                  ).then();
                }

                const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

                if (orderAfterPayment) {
                  response.data.products?.forEach((product) => {
                    orderAfterPayment.products.push(product);
                  });

                  setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
                }

                axios
                  .get(salePageURL + "/crm/upsell-offers", {
                    params: { active: true },
                    headers: { "Content-Type": "application/json" },
                  })
                  .then((response) => {
                    const productCodes = basicEinProducts.map(({ code }) => code?.code);

                    const isUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                      return (
                        productCodes.includes(finishedProduct?.code) &&
                        !productCodes.includes(upsellOffer?.code) &&
                        !disabled &&
                        upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                      );
                    });

                    if (isUpsell) {
                      history.push("/TrademarkUpsellQuestion");
                    } else {
                      history.push("/ThankYou");
                    }
                  })
                  .catch((e) => {
                    history.push("/ThankYou");
                  });
              } else {
                dispatch(boiFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(boiFailure({ message: error.response.data.errors[0] }))
                  : dispatch(boiFailure({ message: error.response.data.message }));
              } else {
                dispatch(boiFailure(error));
              }
            });
        } else {
          dispatch(boiFailure(error));
        }
      });
  };
};

export const delayedBOISubmit = (order, orderId, basicEinProducts, file, history) => {
  return (dispatch) => {
    dispatch(boiStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-delayed-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          dispatch(boiSuccess(response.data));

          if (file) {
            const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
            const formData = new FormData();
            formData.append("file", file);
            fetch(
              process.env.NEXT_PUBLIC_REACT_APP_API +
                "/orders/" +
                response.data.order.id +
                "/products/" +
                response.data.products[0].id +
                "/result-PDF?fileType=BOI_ID",
              {
                method: "POST",
                headers: { Authorization: `Bearer ${token?.token}` },
                body: formData,
              }
            ).then();
          }

          const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

          if (orderAfterPayment) {
            response.data.products?.forEach((product) => {
              orderAfterPayment.products.push(product);
            });

            setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
          }

          axios
            .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/upsell-offers", {
              params: { active: true },
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              const productCodes = basicEinProducts.map(({ code }) => code?.code);

              const isUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                return (
                  productCodes.includes(finishedProduct?.code) &&
                  !productCodes.includes(upsellOffer?.code) &&
                  !disabled &&
                  upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                );
              });

              if (isUpsell) {
                history.push(
                  `/TrademarkUpsellQuestion?order=${history.query.order}&token=${history.query.token}&campaignId=${
                    history.query.campaignId || 2
                  }`
                );
              } else {
                history.push("/ThankYou");
              }
            })
            .catch((e) => {
              history.push("/ThankYou");
            });
        } else {
          dispatch(boiFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(boiFailure({ message: error.response.data.errors[0] }))
            : dispatch(boiFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-delayed-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                dispatch(boiSuccess(response.data));

                if (file) {
                  const { token } = getItemSessionStorage(KEY_ORDER_INFO) || {};
                  const formData = new FormData();
                  formData.append("file", file);
                  fetch(
                    process.env.NEXT_PUBLIC_REACT_APP_API +
                      "/orders/" +
                      response.data.order.id +
                      "/products/" +
                      response.data.products[0].id +
                      "/result-PDF?fileType=BOI_ID",
                    {
                      method: "POST",
                      headers: { Authorization: `Bearer ${token?.token}` },
                      body: formData,
                    }
                  ).then();
                }

                const orderAfterPayment = getItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);

                if (orderAfterPayment) {
                  response.data.products?.forEach((product) => {
                    orderAfterPayment.products.push(product);
                  });

                  setItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT, orderAfterPayment);
                }

                axios
                  .get(salePageURL + "/crm/upsell-offers", {
                    params: { active: true },
                    headers: { "Content-Type": "application/json" },
                  })
                  .then((response) => {
                    const productCodes = basicEinProducts.map(({ code }) => code?.code);

                    const isUpsell = response?.data?.some(({ finishedProduct, upsellOffer, disabled }) => {
                      return (
                        productCodes.includes(finishedProduct?.code) &&
                        !productCodes.includes(upsellOffer?.code) &&
                        !disabled &&
                        upsellOffer?.code === "TRADEMARK_RegisterTrademark"
                      );
                    });

                    if (isUpsell) {
                      history.push(
                        `/TrademarkUpsellQuestion?order=${history.query.order}&token=${
                          history.query.token
                        }&campaignId=${history.query.campaignId || 2}`
                      );
                    } else {
                      history.push("/ThankYou");
                    }
                  })
                  .catch((e) => {
                    history.push("/ThankYou");
                  });
              } else {
                dispatch(boiFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(boiFailure({ message: error.response.data.errors[0] }))
                  : dispatch(boiFailure({ message: error.response.data.message }));
              } else {
                dispatch(boiFailure(error));
              }
            });
        } else {
          dispatch(boiFailure(error));
        }
      });
  };
};

export const boiStarted = () => ({
  type: "BOI_STARTED",
});

export const boiSuccess = (order) => ({
  type: "BOI_SUCCESS",
  order: order,
});

export const boiFailure = (error) => ({
  type: "BOI_FAILURE",
  error: error,
});
export const monexaSubmit = (order, orderId, history) => {
  return (dispatch) => {
    dispatch(monexaStarted());
    const clid = restoreLocalValue("gclid");
    if (clid) {
      order.order ? (order.order.clid = clid) : (order.order = { clid });
    }

    const source = restoreLocalValue("source");
    if (source) {
      order.order ? (order.order.source = source) : (order.order = { source });
    }

    const keyword = restoreLocalValue("keyword");
    if (keyword) {
      order.order ? (order.order.keyword = keyword) : (order.order = { keyword });
    }

    const adAccount = restoreLocalValue("adAccount");
    if (adAccount) {
      order.order ? (order.order.adAccount = adAccount) : (order.order = { adAccount });
    }
    let params;
    if (localStorage.getItem("crmSessionId")) {
      let crmSessionId = localStorage.getItem("crmSessionId");
      params = { crmSessionId };
    }
    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderId + "/create-delayed-upsale", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then((response) => {
        // send success action
        if (response.data.products[0].paymentStatus === "Success") {
          // dispatch(monexaSuccess(response.data));
          history.push("/ThankYou");
        } else {
          dispatch(monexaFailure({ message: response.data.products[0].paymentStatus }));
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          error.response.data.errors
            ? dispatch(monexaFailure({ message: error.response.data.errors[0] }))
            : dispatch(monexaFailure({ message: error.response.data.message }));
        } else if (error.request) {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(/\/+$/, "");
          axios
            .post(salePageURL + "/crm/orders/" + orderId + "/create-delayed-upsale", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then((response) => {
              // send success action
              if (response.data.products[0].paymentStatus === "Success") {
                // dispatch(monexaSuccess(response.data));
                history.push("/ThankYou");
              } else {
                dispatch(monexaFailure({ message: response.data.products[0].paymentStatus }));
              }
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response && error.response.data) {
                error.response.data.errors
                  ? dispatch(monexaFailure({ message: error.response.data.errors[0] }))
                  : dispatch(monexaFailure({ message: error.response.data.message }));
              } else {
                dispatch(monexaFailure(error));
              }
            });
        } else {
          dispatch(monexaFailure(error));
        }
      });
  };
};
export const monexaStarted = () => ({
  type: "MONEXA_STARTED",
});

export const monexaSuccess = (order) => ({
  type: "MONEXA_SUCCESS",
  order: order,
});

export const monexaFailure = (error) => ({
  type: "MONEXA_FAILURE",
  error: error,
});
